<div class="d-none d-md-block">
    <app-nav></app-nav>
</div>
<div class="d-block d-md-none">
    <app-small-nav></app-small-nav>
</div>
